var messages = {
  zoomInText: 'Zoom In',
  zoomOutText: 'Zoom Out',
  rotateRightText: 'Rotate',
  resetText: 'Reset',
  copyText: 'Copy',
  downloadText: 'Download',
  originalText: 'Original',
  tipsContent: 'Press ESC to exit fullscreen'
};
export default messages;